import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import vw from 'styles/utils';

function IconTitle(props) {
  const {borderBottom, iconImage, title, moreUrl} = props;

  return (
    <Root>
      <Row borderBottom={borderBottom}>
        <Col>
          <Icon src={iconImage} />
          <Title>{title}</Title>
        </Col>
        <ColMore show={moreUrl}>
          <ReadMore href={moreUrl} target="_blank" rel="noreferrer">
            <h5>更多</h5>
            <img src={require('assets/images/icons/bi_arrow-down-circle.png')} alt="bi_arrow-down-circle"/>
          </ReadMore>
        </ColMore>
      </Row>
    </Root>
  )
}

IconTitle.propTypes = {
  iconImage: PropTypes.node,
  moreUrl: PropTypes.string,
  title: PropTypes.string,
}

const Root = styled.div`
  ${vw('padding-bottom', 10, 15, 24)}
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: ${props => props.borderBottom && '1px solid #DADADA'};
  
  /* ${vw('margin-bottom', 10, 15)} */
`;

const Col = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const ColMore = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  flex-direction: row;
  align-items: center;
`;

const Icon = styled.img`
  width: auto;
  height: auto;

  ${vw('max-width', 10, 15, 28)}
  ${vw('max-height', 10, 15, 28)}
  ${vw('margin-right', 6, 13)}
`;

const Title = styled.h5`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;

  ${vw('font-size', 12, 18)}
  ${vw('line-height', 20, 28)}
`;

const ReadMore = styled.a`
  display: flex;
  align-items: center;
  background: none;
  transition: all 0.25s;

  
  ${vw('padding-top', 2, 1.5, 3)}
  ${vw('padding-bottom', 2, 1.5, 3)}
  ${vw('padding-left', 10, 15.5, 10)}
  ${vw('padding-right', 10, 15.5, 10)}

  &:hover{
    /* background: #DADADA; */
    
    > h5 {
      color: #3398DC;
    }
  }

  

  > h5 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    color: #252525;
    ${vw('font-size', 10, 12, 14)}
    ${vw('line-height', 16, 22)}
  }

  > img {
    ${vw('width', 14)}
    ${vw('margin-left', 10)}
  }
`;


export default IconTitle
